import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "md:ml-72 md:mt-10 md:text-left m-4 mt-12 text-center"
}
const _hoisted_2 = { key: 2 }

import { computed, onMounted } from "vue";
import { useStore } from "@/store/index.store";
import Notifications from "@/components/organisms/notifications/BaseNotifications.vue";
import Sidebar from "@/components/organisms/sidebar/BaseSidebar.vue";
import router from "@/router/index.router";
import { routesWithoutDrawer } from "@/types/router.type";
import { CookieTokenName, getCookieToken } from "@/helpers/cookies.helper";
import { SetInterceptorLogIn } from "@/helpers/auth.helper";
import { ActionTypes as configActionTypes } from "@/store/modules/Config/action-types";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const showDrawer = computed(
  () =>
    !routesWithoutDrawer.includes(
      (router.currentRoute.value.name as string) || ""
    )
);

onMounted(async () => {
  const store = useStore();
  // Check if the user is LoggedIn and updates status
  if (!store.getters.isLoggedIn) {
    const token = getCookieToken(CookieTokenName);
    if (token) {
      await SetInterceptorLogIn(token);
      await store.dispatch(configActionTypes.SET_ISLOGGEDIN, true);
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showDrawer.value)
      ? (_openBlock(), _createBlock(Sidebar, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(Notifications, {
      class: "bg-gray-50 fixed left-0 sm:left-auto bottom-0 right-0 sm:mr-4 mb-4 w-full sm:w-6/12 lg:w-4/12 xl:w-3/12 pointer-events-none",
      style: {"z-index":"2100"}
    }),
    (_unref(router).currentRoute.value.name !== 'Login')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_router_view)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_router_view)
        ]))
  ], 64))
}
}

})